import { ExternalLink } from 'lucide-react';
import React from 'react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';
import Button from 'tailwind-components/Button';

const iconSizeByButtonSize = {
  xsmall: 14,
  small: 18,
  medium: 20,
  large: 22
};

export default function ExternalLinkButton({
  href,
  text,
  size = 'small',
  fill = true,
  className
}) {
  const iconSize = iconSizeByButtonSize[size] ?? 18;

  return (
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      className={cn(
        'min-w-0',
        fill ? 'block w-full!' : 'inline-flex w-auto shrink-0',
        className
      )}
    >
      <Button
        variant='secondary'
        size={size}
        fill={fill}
        icon={<ExternalLink size={iconSize} />}
        text={text}
        rounded='medium'
      />
    </a>
  );
}

ExternalLinkButton.propTypes = {
  href: propTypes.string.isRequired,
  text: propTypes.string.isRequired,
  size: propTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
  fill: propTypes.bool,
  className: propTypes.string
};
